import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../../stores/actions/index";
import { showToast } from "../../helpers/toast.js";
import { Trans, translate } from "react-i18next";
import ContentWrapper from "../Layout/ContentWrapper.js";
import {
  Container,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Input,
  Button,
} from "reactstrap";
import { selectStyle } from "../../config/selectStyle.js";
import Select from "react-select";
import { apiPath } from "../../config/config";
import { getCommonHeaders } from "../../utils/utilities";
import ReactDatePicker from "react-datepicker";
import CardTool from "../Common/CardTool.js";
import AuditTrailTable from "./AuditTrailTable.js";
import * as moment from "moment";

const now = new Date();
class AuditTrail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: null,
      startDate: new Date(),
      endDate: new Date(),
      event: {
        id: "",
        name: this.props.t("dashboard.selectEvent"),
      },
      accountId: null,
      action: {
        id: "",
        name: this.props.t("dashboard.selectAction"),
      },
      nextToken: null,
      downloadPDFStatus: "",
      eventList: [
        {
          id: "",
          name: this.props.t("dashboard.selectEvent"),
        },
        {
          id: "USER",
          name: this.props.t("dashboard.user"),
        },
        {
          id: "REPORT",
          name: this.props.t("dashboard.report"),
        },
        {
          id: "DEVICE",
          name: this.props.t("dashboard.device"),
        },
        {
          id: "GATEWAY",
          name: "Gateway",
        },
        {
          id: "ALARM",
          name: this.props.t("dashboard.alarm"),
        },
        {
          id: "ACCOUNT",
          name: this.props.t("dashboard.account"),
        },
        {
          id: "LIGHT_PROFILE",
          name: "Light profile",
        },
        {
          id: "LOCATION",
          name: this.props.t("dashboard.location"),
        },
        {
          id: "MAP",
          name: this.props.t("dashboard.map"),
        },
      ],
      actionList: [
        { id: "", name: this.props.t("dashboard.selectAction") },
        { id: "LOGIN", name: this.props.t("dashboard.login") },
        { id: "LOGOUT", name: this.props.t("dashboard.logout") },
        { id: "REGISTER", name: this.props.t("dashboard.register") },
        {
          id: "FORGOT_PASSWORD",
          name: this.props.t("dashboard.forgotPassword"),
        },
        { id: "ADD", name: this.props.t("dashboard.add") },
        { id: "UPDATE", name: this.props.t("dashboard.update") },
        { id: "DELETE", name: this.props.t("dashboard.delete") },
        {
          id: "ADD_DEVICE_TOKEN",
          name: this.props.t("dashboard.addDeviceToken"),
        },
        {
          id: "REMOVE_DEVICE_TOKEN",
          name: this.props.t("dashboard.removeDeviceToken"),
        },
        { id: "GET", name: this.props.t("dashboard.get") },
        { id: "DOWNLOAD_PDF", name: this.props.t("dashboard.downloadPDF") },
        { id: "DOWNLOAD_CSV", name: this.props.t("dashboard.downloadCSV") },
        { id: "ASSIGN", name: this.props.t("dashboard.assignSubUser") },
        { id: "UNASSIGN", name: this.props.t("dashboard.unAssignSubUser") },
        {
          id: "UNASSIGN_LOCATION",
          name: this.props.t("dashboard.unAssignLocation"),
        },
        { id: "SET_ALARM", name: this.props.t("dashboard.setAlarm") },
        { id: "UPDATE_ALARM", name: this.props.t("dashboard.updateAlarm") },
        { id: "DELETE_ALARM", name: this.props.t("dashboard.deleteAlarm") },
        {
          id: "SET_ALARM_PROFILE",
          name: this.props.t("dashboard.setAlarmProfile"),
        },
        {
          id: "UPDATE_ALARM_PROFILE",
          name: this.props.t("dashboard.updateAlarmProfile"),
        },
        {
          id: "DELETE_ALARM_PROFILE",
          name: this.props.t("dashboard.deleteAlarmProfile"),
        },
        { id: "ENABLE_ALARM", name: this.props.t("dashboard.enableAlarm") },
        {
          id: "UPDATE_FREQUENCY",
          name: this.props.t("dashboard.updateFrequency"),
        },
        { id: "ADD_SMS_LIMIT", name: this.props.t("dashboard.setSMSLimit") },
        {
          id: "UPDATE_ACCOUNT_SETTINGS",
          name: this.props.t("dashboard.updateAccountSetting"),
        },
        {
          id: "UPDATE_VOICE_CALL",
          name: this.props.t("dashboard.updateVoiceCall"),
        },
        {
          id: "UPDATE_OFFLINE_SETTING",
          name: this.props.t("dashboard.updateOfflineSettings"),
        },
        {
          id: "SET_TEMPLATE_TO_USER",
          name: this.props.t("dashboard.setMessageTemplateToUser"),
        },
      ],
    };
  }

  componentDidMount() {
    const { getAuditTrail, getAccountList } = this.props;
    this.handleThemeChange();
    this.props.getAuditTrail({
      limit: this.state.limit ? this.state.limit : null,
      startDate: this.state.startDate
        ? moment(this.state.startDate).format("YYYY-MM-DD")
        : null,
      endDate: this.state.endDate
        ? moment(this.state.endDate).format("YYYY-MM-DD")
        : null,
      event: this.state.event.id ? this.state.event.id : null,
      accountId: this.state.accountId ? this.state.accountId : null,
      action: this.state.action.id ? this.state.action.id : null,
      nextToken: null,
    });
    getAccountList();
    window.addEventListener("storage", this.handleThemeChange);
  }
  handleThemeChange = () => {
    this.setState({
      themeState:
        document.documentElement.getAttribute("data-theme") === "light"
          ? "light"
          : "dark",
    });
  };
  componentDidUpdate(prevProps) {
    if (prevProps.success !== this.props.success && this.props.success) {
      showToast(this.props.t(this.props.success), "success");
      this.changePage(1);
    }
    if (prevProps.error !== this.props.error && this.props.error) {
      showToast(this.props.error, "error");
    }
    if (prevProps.reload !== this.props.reload && this.props.reload) {
      this.props.setModal({ showModal: false, modalName: "", modalData: {} });
      this.props.getAuditTrail({
        page: 1,
        pageSize: 10,
      });
    }
    if (this.props.task && this.props.task.taskId) {
      if (
        !prevProps.task ||
        !prevProps.task.taskId ||
        prevProps.task.taskId !== this.props.task.taskId
      ) {
        this.handlePolling(this.props.task.taskId);
      }
    }
  }

  handlePolling = async (taskId) => {
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    try {
      const headers = getCommonHeaders();
      let url = `${apiPath.baseUrl}${apiPath.auditTrail.task}`;
      url = url.replace("{id}", taskId);
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const result = await response.json();
      if (result.data && result.data.status !== "completed") {
        let status = result.data.status;
        if (result.data.progress) {
          status += " " + result.data.progress + "%";
        }

        this.setState({
          ...this.state,
          downloadPDFStatus: status,
        });
        await delay(5000);
        this.handlePolling(taskId);
      } else if (result.data && result.data.status === "completed") {
        this.setState({
          ...this.state,
          downloadPDFStatus: "",
        });
        window.open(result.data.resultUrl, "_blank");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  changePage = (nextToken = null) => {
    if (
      new Date(this.state.endDate).getTime() <
      new Date(this.state.startDate).getTime()
    ) {
      showToast(
        this.props.t("dashboard.startDateShouldNotBeGreaterThanEndDate"),
        "error"
      );
    } else {
      this.props.getAuditTrail({
        limit: this.state.limit ? this.state.limit : null,
        startDate: this.state.startDate ? this.state.startDate : null,
        endDate: this.state.endDate ? this.state.endDate : null,
        event: this.state.event.id ? this.state.event.id : null,
        accountId: this.state.accountId ? this.state.accountId : null,
        action: this.state.action.id ? this.state.action.id : null,
        nextToken: nextToken ? nextToken : null,
      });
    }
  };

  downloadPDF = () => {
    this.props.pdfExportAuditTrail({
      limit: this.state.limit ? this.state.limit : null,
      startDate: this.state.startDate ? this.state.startDate : null,
      endDate: this.state.endDate ? this.state.endDate : null,
      event: this.state.event.id ? this.state.event.id : null,
      accountId: this.state.accountId ? this.state.accountId : null,
      action: this.state.action.id ? this.state.action.id : null,
    });
  };

  handleChangeEvent = (event) => {
    this.setState({ event });
  };

  isEventSelected = (option) => {
    return this.state.event.id === option.id ? true : false;
  };

  handleChangeAction = (action) => {
    this.setState({ action });
  };

  isActionSelected = (option) => {
    return this.state.action.id === option.id ? true : false;
  };

  render() {
    const { data, loading, task } = this.props;
    const isLightMode =
      document.documentElement.getAttribute("data-theme") === "light";
    return (
      <ContentWrapper>
        <div className="content-heading">
          <div>
            Audit Trail
            <small>
              <Trans i18nKey="dashboard.WELCOME"></Trans>
            </small>
          </div>
        </div>

        <Card className="card-default" style={{ padding: "2px" }}>
          <CardHeader className="d-flex align-items-center justify-content-between">
            <CardTitle>{this.props.t("dashboard.auditTrail")}</CardTitle>
            <CardTool refresh onRefresh={(_, done) => setTimeout(done, 2000)} />
          </CardHeader>
          <div
            style={{
              height: "1px",
              width: "100%",
              background: "#ccc",
            }}
          />
          <div className=" m-2  items-center">
            <div className="row" style={{ alignItems: "center" }}>
              {/*}
                    <div className="col-3 mt-2">
                      
                    <select style={{
                        backgroundColor: "#272934", 
                        color: "#fff",
                        borderBottom: "1px solid black",
                        width: "100%",
                        padding: "9px",
                        opacity: "0.7"}}
                        onChange={(data) => this.setState({ accountId: data.target.value })}
                        >
                        <option value="0" selected={!this.state.accountId ? "selected" : "" }>Select...</option>
                        {account.map((el) => (
                          <option value={el.id} selected={(el.id === this.state.accountId) ? "selected" : "" }>{el.companyName}</option>
                        )
                        )}
                      </select>
                    </div>  
                    {*/}
              <div
                className="d-flex justify-content-between items-center"
                style={{
                  // backgroundColor: "red",
                  width: "40%",
                }}
              >
                <div className="col-6 mt-2">
                  <Select
                    styles={selectStyle}
                    name="eventId"
                    value={this.state.event}
                    onChange={this.handleChangeEvent}
                    options={this.state.eventList}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option}`}
                    isOptionSelected={(option) => {
                      this.isEventSelected(option);
                    }}
                  />
                  {/* <select
                    style={{
                      backgroundColor: "#272934",
                      color: "#fff",
                      borderBottom: "1px solid black",
                      width: "100%",
                      padding: "9px",
                      opacity: "0.7",
                    }}
                    onChange={(data) =>
                      this.setState({ event: data.target.value })
                    }
                  >
                    <option value="">Select event...</option>
                    <option value="USER">User</option>
                    <option value="REPORT">Report</option>
                    <option value="DEVICE">Device</option>
                    <option value="GATEWAY">Gateway</option>
                    <option value="GATEWAY">Alarm</option>
                    <option value="ACCOUNT">Account</option>
                    <option value="LIGHT_PROFILE">Light profile</option>
                    <option value="LOCATION">Location</option>
                    <option value="LOCATION">Map</option>
                  </select> */}
                </div>
                <div className="col-6 mt-2">
                  <Select
                    styles={selectStyle}
                    name="actionId"
                    value={this.state.action}
                    onChange={this.handleChangeAction}
                    options={this.state.actionList}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option}`}
                    isOptionSelected={(option) => {
                      this.isActionSelected(option);
                    }}
                  />
                  {/* <select
                    style={{
                      backgroundColor: "#272934",
                      color: "#fff",
                      borderBottom: "1px solid black",
                      width: "100%",
                      padding: "9px",
                      opacity: "0.7",
                    }}
                    onChange={(data) =>
                      this.setState({ action: data.target.value })
                    }
                  >
                    <option value="">Select action...</option>
                    <option value="LOGIN">Login</option>
                    <option value="LOGOUT">Logout</option>
                    <option value="REGISTER">Register</option>
                    <option value="FORGOT_PASSWORD">Forgot password</option>
                    <option value="ADD">Add</option>
                    <option value="UPDATE">Update</option>
                    <option value="DELETE">Delete</option>
                    <option value="ADD_DEVICE_TOKEN">Add device token</option>
                    <option value="REMOVE_DEVICE_TOKEN">
                      Remove device token
                    </option>
                    <option value="GET">Get</option>
                    <option value="DOWNLOAD_PDF">Download PDF</option>
                    <option value="DOWNLOAD_CSV">Download CSV</option>
                    <option value="ASSIGN">Assign sub user</option>
                    <option value="UNASSIGN">Unassign sub user</option>
                    <option value="UNASSIGN_LOCATION">Unassign location</option>
                    <option value="SET_ALARM">Set alarm</option>
                    <option value="UPDATE_ALARM">Update alarm</option>
                    <option value="DELETE_ALARM">Delete alarm</option>
                    <option value="SET_ALARM_PROFILE">Set alarm profile</option>
                    <option value="UPDATE_ALARM_PROFILE">
                      Update alarm profile
                    </option>
                    <option value="DELETE_ALARM_PROFILE">
                      Delete alarm profile
                    </option>
                    <option value="ENABLE_ALARM">Enable alarm</option>
                    <option value="UPDATE_FREQUENCY">Update frequency</option>
                    <option value="ADD_SMS_LIMIT">Set sms limit</option>
                    <option value="UPDATE_ACCOUNT_SETTINGS">
                      Update account settings
                    </option>
                    <option value="UPDATE_VOICE_CALL">Update voice call</option>
                    <option value="UPDATE_OFFLINE_SETTING">
                      Update offline settings
                    </option>
                    <option value="SET_TEMPLATE_TO_USER">
                      Set message template to user
                    </option>
                  </select> */}
                </div>
              </div>
              <div
                className=" mt-2 d-flex items-center"
                style={{
                  display: "flex",
                  width: "58%",
                  // backgroundColor: "yellow",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    gap: "10px",
                  }}
                  className="styleDatePicker col-6"
                >
                  {this.props.t("dashboard.startDate")}:{" "}
                  <ReactDatePicker
                    selected={this.state.startDate}
                    onChange={(date) => this.setState({ startDate: date })}
                    className="form-control form-control-sm w-100"
                    // style={{ width: "80%" }}
                    //showTimeSelect
                    //showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Date"
                    dateFormat="yyyy-MM-dd HH:mm:ss"
                  />
                </div>
                <div
                  className=" styleDatePicker"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "60%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      gap: "10px",
                    }}
                  >
                    {this.props.t("dashboard.endDate")}:
                    <ReactDatePicker
                      selected={this.state.endDate}
                      onChange={(date) => this.setState({ endDate: date })}
                      // style={{ width: "100%" }}
                      className="form-control form-control-sm w-100"
                      //showTimeSelect
                      //showTimeSelectOnly
                      timeIntervals={15}
                      timeCaption="Date"
                      dateFormat="yyyy-MM-dd HH:mm:ss"
                    />
                  </div>
                </div>
              </div>
              <div className="col-4 mt-2">
                {/* <Button
                    onClick={() => {
                      this.changePage();
                    }}
                    color="info"
                    type="button"
                  >
                    {this.props.t("dashboard.search")}
                  </Button> */}
                <button
                  className="mr-2"
                  style={{
                    backgroundColor: isLightMode ? "white" : "#272a34",
                    color: isLightMode ? "#272a34" : "white",
                    border: isLightMode ? "1px solid #c4c4c4" : "none",
                    padding: "6px 20px",
                    cursor: "pointer",
                    borderRadius: "5px",
                  }}
                  onClick={() => {
                    this.changePage();
                  }}
                >
                  {this.props.t("dashboard.search")}
                </button>
                <span className="ml-2">
                  {/* <Button
                      onClick={() => {
                        this.setState({
                          startDate: null,
                          endDate: null,
                          event: {
                            id: "",
                            name: this.props.t("dashboard.selectEvent"),
                          },
                          action: {
                            id: "",
                            name: this.props.t("dashboard.selectAction"),
                          },
                          accountId: null,
                        });
                      }}
                      color="info"
                      type="button"
                    >
                      {this.props.t("dashboard.reset")}
                    </Button> */}
                  <button
                    className="mr-2"
                    style={{
                      backgroundColor: isLightMode ? "white" : "#272a34",
                      color: isLightMode ? "#272a34" : "white",
                      border: isLightMode ? "1px solid #c4c4c4" : "none",
                      padding: "6px 20px",
                      cursor: "pointer",
                      borderRadius: "5px",
                    }}
                    onClick={() => {
                      this.setState({
                        startDate: null,
                        endDate: null,
                        event: {
                          id: "",
                          name: this.props.t("dashboard.selectEvent"),
                        },
                        action: {
                          id: "",
                          name: this.props.t("dashboard.selectAction"),
                        },
                        accountId: null,
                      });
                    }}
                  >
                    {this.props.t("dashboard.reset")}
                  </button>
                </span>
                {!this.state.downloadPDFStatus ||
                this.state.downloadPDFStatus === "completed" ? (
                  <span className="">
                    {/* <Button
                        onClick={() => {
                          this.downloadPDF();
                        }}
                        color="info"
                        type="button"
                      >
                        {this.props.t("dashboard.downloadPDF")}
                      </Button> */}
                    <button
                      className=""
                      style={{
                        backgroundColor: isLightMode ? "white" : "#272a34",
                        color: isLightMode ? "#272a34" : "white",
                        border: isLightMode ? "1px solid #c4c4c4" : "none",
                        padding: "6px 20px",
                        cursor: "pointer",
                        borderRadius: "5px",
                      }}
                      onClick={() => {
                        this.downloadPDF();
                      }}
                    >
                      <span className="mr-2">
                        <i
                          className="fa fa-download"
                          aria-hidden="true"
                          style={{ color: isLightMode ? "#272a34" : "white" }}
                        ></i>
                      </span>
                      {this.props.t("dashboard.downloadPDF")}
                    </button>
                  </span>
                ) : (
                  <>
                    <span className={"fas fa-spinner fa-spin ml-2"}></span>{" "}
                    {this.state.downloadPDFStatus}
                  </>
                )}
              </div>
            </div>
          </div>
          <CardBody>
            {data && data.length > 0 && (
              <AuditTrailTable
                data={data}
                editMessageTemplate={this.editMessageTemplate}
                deleteMessageTemplate={this.deleteMessageTemplate}
                changePage={(page) => this.changePage(page)}
              ></AuditTrailTable>
            )}
            {!!loading && <h3 className="text-center">Loading...</h3>}
          </CardBody>
        </Card>
        {/* <Container>
        </Container> */}
      </ContentWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.auditTrail.loading,
    data: state.auditTrail.data,
    meta: state.auditTrail.meta,
    success: state.auditTrail.success,
    account: state.account.data,
    task: state.auditTrail.task,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAuditTrail: (data) => dispatch(actions.getAuditTrail(data)),
    pdfExportAuditTrail: (data) => dispatch(actions.pdfExportAuditTrail(data)),
    getAccountList: (data) => dispatch(actions.getAccountList(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(translate("translations")(AuditTrail));
